import { useTranslation } from 'react-i18next';

import { ReactComponent as HelpIcon } from '../../../../../../assets/icons/question.svg';
import { showIntercom } from '../../../../../hooks/useIntercom/useIntercom';
import { TRANSLATIONS_GLOBAL } from '../../../../../translations/commons';
import Tooltip from '../../../Tooltip/Tooltip';

import './HelpButton.scss';

interface IHelpButtonProps {
  collapsed: boolean;
}

const HelpButton = ({ collapsed }: IHelpButtonProps) => {
  const { t } = useTranslation();

  const label = t(TRANSLATIONS_GLOBAL.sidebar.help);
  const buttonClass = ['help-button', collapsed ? 'help-button--collapsed' : ''].filter(Boolean).join(' ');

  const button = (
    <button type="button" className={buttonClass} aria-label={label} onClick={showIntercom}>
      <span className="help-button__icon">
        <HelpIcon />
      </span>
      {!collapsed && <span className="help-button__label">{label}</span>}
    </button>
  );

  if (collapsed) {
    return (
      <Tooltip content={label} placement="right">
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default HelpButton;
